module.exports = __webpack_public_path__ + "fonts/cockpitTitle.1726685c.ttf";